<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="select-wrapper">
    <select
      :id="id"
      :value="modelValue"
      class="custom-select w-full"
      :disabled="disabled"
      :aria-describedby="`${id}-help`"
      :class="{
        'p-invalid': validation?.$error,
      }"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option v-if="placeholder" value="" disabled selected>
        {{ placeholder }}
      </option>
      <template v-for="(option, index) in options" :key="index">
        <option
          :value="optionValue ? option[optionValue] : option"
          :disabled="optionDisabled ? optionDisabled(option) : false"  class="dropdownTxt"
        >
          {{ optionLabel ? option[optionLabel] : option }}
        </option>
      </template>
    </select>
    <!-- SVG Icon -->
    <span class="select-icon">
      <img :src="iconSvg" alt="Dropdown icon" />
    </span>
    <span
      v-if="validation?.$error && validation?.required?.$invalid"
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ PropName }} is required.
    </span>
    <span
      v-else-if="
        validation?.$error &&
        validation?.requiredIf &&
        validation?.requiredIf.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.requiredIf.$message.replace("value", PropName) }}
    </span>
  </div>
</template>

<script>
import iconSvg from '@/assets/icons/icon-down.svg'; // Adjust the path and file name as needed

export default {
  props: {
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    options: {
      type: Array,
      required: false,
    },
    modelValue: {
      type: [String, Number, Object],
      default: "",
    },
    optionLabel: {
      type: String,
      default: "",
    },
    optionValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    optionDisabled: {
      type: Function,
      default: null,
    },
    PropName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconSvg, // Make the imported SVG available in the template
    };
  },
};
</script>

<style lang="scss" scoped>
.select-wrapper {
  position: relative;
  display: inline-block;
  width: 395px; /* Match the select width */
}

.custom-select:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

.custom-select {
  display: flex;
  align-items: center;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem !important;
  height: 40px;
  width: 100%;
  line-height: 1.5;
  font-weight: 400;
  font-size: 16px !important;
  color: #777 !important;
  text-decoration: none;
  box-shadow: none;
  background: none;
  font-family: "Voyado Text";
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 30px; /* Space for the icon */
  appearance: none; /* Remove default arrow */
  padding: 7px;
}
.select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* Prevent icon from interfering with select */
}
.select-icon img {
  width: 16px; /* Adjust size as needed */
  height: 16px;
}
.dropdownTxt{
  color:#21211f;
}
</style>